<template>
  <div class="grid grid-cols-[200px_1fr] gap-x-2 overflow-hidden border-t">
    <div class="pt-5 overflow-y-auto pr-2">
      <strong class="text-xs">审核进度</strong>
      <el-timeline class="!text-xs !mt-3" style="padding-left: 5px">
        <el-timeline-item
          :hollow="item.status == 0"
          :type="
            item.status === 0
              ? 'info'
              : item.status === 1
              ? 'primary'
              : 'danger'
          "
          hide-timestamp
          v-for="item in state.flowApproveStepList"
          :key="item"
        >
          <div class="flex flex-col gap-y-1">
            <div class="flex gap-x-3 flex-wrap gap-y-1">
              <strong>{{ item.step_name }}</strong>
              <c_status
                arrName="Common_Check_Status"
                :value="item?.status"
                :key="item?.status"
              />
            </div>
            <c_cell title="操作人" :size="12" class="mt-1">
              <ul>
                <text>{{ item?.approve_admin_name }}</text>
                <text class="text-gray-400 ml-1">{{
                  item?.approve_department_name
                }}</text>
              </ul>
            </c_cell>
            <ul class="text-xs" v-if="item?.approve_time">
              <text class="text-gray-400">时间：</text>
              <text> {{ item?.approve_time }}</text>
            </ul>
            <ul v-if="item?.log?.msg" class="text-xs">
              <text class="text-gray-400">备注：</text>
              <text>{{ item?.log?.msg }}</text>
            </ul>
          </div>
        </el-timeline-item>
      </el-timeline>
      <template v-if="state.meetingAccounting?.status == 0 && !props.search">
        <strong class="text-xs">审核操作</strong>
        <c_cell title="说明" titleTop class="mt-2">
          <el-input
            v-model="state.remark"
            type="textarea"
            :autosize="{ minRows: 3 }"
            placeholder=""
            class="round"
          />
        </c_cell>
        <div class="items-center justify-center grid grid-cols-[30%_1fr] mt-3">
          <el-button type="danger" size="large" @click="onSubmit(2)"
            >不通过</el-button
          >
          <el-button type="primary" size="large" @click="onSubmit(1)"
            >通过</el-button
          >
        </div>
      </template>
    </div>
    <div class="flex flex-col overflow-y-auto gap-y-3">
      <ul class="font-bold text-center text-gray-900 text-base mt-5">
        恒路传媒会务有限公司会议项目核算单
      </ul>
      <c_cell title="会议名称" class="mt-5">
        <template #default>
          <strong>{{ state.meeting?.name }}</strong>
        </template>
      </c_cell>
      <ul class="grid grid-cols-2 mt-3">
        <c_cell title="会议编号" :value="state.meeting?.number" />
        <c_cell
          title="会议时间"
          :value="state.meeting?.start_date + ' ~ ' + state.meeting?.end_date"
        />
      </ul>
      <ul class="flex gap-x-5 mt-3">
        <c_cell title="会议负责人" :value="state.meeting?.belonger_name" />
        <!-- <c_cell title="设计师" :value="state.meeting?.start_time" />
      <c_cell title="车队调度员" :value="state.meeting?.start_time" />
      <c_cell title="物料采购员" :value="state.meeting?.start_time" /> -->
      </ul>
      <div class="border rounded-lg p-2.5">
        <strong>一、会议核算审批摘要信息</strong>
        <div class="flex flex-col gap-y-3 mt-5">
          <ul class="flex gap-x-5">
            <c_cell title="总产值（甲方收款）">
              <template #default>
                <c_money
                  :key="state.meetingAccounting?.receivable_amount"
                  :value="state.meetingAccounting?.receivable_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="已收款">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.collected_amount"
                  :key="state.meetingAccounting?.collected_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="欠款">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.uncollected_amount"
                  :key="state.meetingAccounting?.uncollected_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="报账总金额（乙方）">
              <template #default>
                <c_money
                  :key="state.meetingAccounting?.bill_amount"
                  :value="state.meetingAccounting?.bill_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="报账金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.bill_item_amount"
                  :key="state.meetingAccounting?.bill_item_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="服务费">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.service_fee_amount"
                  :key="state.meetingAccounting?.service_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="税费">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.tax_fee_amount"
                  :key="state.meetingAccounting?.tax_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs" style="margin-left: -20px">
              （报账税率({{
                $formatDecimal(state.meetingAccounting?.tax_fee_rate)
              }}%)）
            </span>
          </ul>
          <ul class="flex gap-x-5 mt-5">
            <c_cell title="采购金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.purchase_amount"
                  :key="state.meetingAccounting?.purchase_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <!-- <c_cell title="物料采购金额合计">
            <template #default>
              <c_money
                :value="state.meetingAccounting?.material_purchase_amount"
                :key="state.meetingAccounting?.material_purchase_amount"
                bold
                :prefix="false"
                color="#080"
              />
            </template>
          </c_cell>
          <c_cell title="费用采购金额合计">
            <template #default>
              <c_money
                :value="state.meetingAccounting?.expense_purchase_amount"
                :key="state.meetingAccounting?.expense_purchase_amount"
                bold
                :prefix="false"
                color="#080"
              />
            </template>
          </c_cell> -->
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="税务成本">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.cost_tax_fee_amount"
                  :key="state.meetingAccounting?.cost_tax_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （（应税报账金额合计 + 服务费）* 成本税率（{{
                $formatDecimal(state.meetingAccounting?.cost_tax_fee_rate)
              }}%)）
            </span>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="毛利">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.gross_profit"
                  :key="state.meetingAccounting?.gross_profit"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （报账总金额（乙方）- 采购金额合计 - 税务成本）
            </span>
            <c_cell title="毛利率">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.gross_profit_rate"
                  :key="state.meetingAccounting?.gross_profit_rate"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="设计师应发提成">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.designer_commission"
                  :key="state.meetingAccounting?.designer_commission"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （（参与提成报账金额合计 - 参与提成采购金额合计）*
              设计师提成系数（{{
                $formatDecimal(
                  state.meetingAccounting?.designer_commission_rate,
                )
              }}%））
            </span>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="项目经理应发提成">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.manager_commission"
                  :key="state.meetingAccounting?.manager_commission"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （（毛利 - 设计师应发提成）* 项目经理提成系数（{{
                $formatDecimal(
                  state.meetingAccounting?.manager_commission_rate,
                )
              }}%））
            </span>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="会议结转收入">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.forward_amount"
                  :key="state.meetingAccounting?.forward_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs"> （已收款 - 报账总金额） </span>
          </ul>
        </div>
      </div>
      <strong>二、会议成本及乙方报账金额明细如下：</strong>
      <div>
        <el-table
          :data="state.meetingPurchaseItemList"
          v-loading="!Array.isArray(state.meetingPurchaseItemList)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column
            label="分类"
            prop="d_cost_type_name"
            :formatter="$tab_TextFormat"
            :width="160"
          />
          <el-table-column
            label="供应商"
            prop="supplier.name"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="备注"
            prop="remark"
            :formatter="$tab_TextFormat"
          />
          <el-table-column label="采购单价/数量/天数/总金额" align="right">
            <template #default="{ row }">
              <text style="color: #080">{{ $priceFormat(row.price) }}</text>
              <text class="text-gray-400">{{ "/" + row.count }}</text>
              <text class="text-gray-400">{{
                "/" + (row.day_count || "-") + "/"
              }}</text>
              <strong style="color: #080">
                {{ $priceFormat(row.amount) }}
              </strong>
            </template>
          </el-table-column>
          <el-table-column label="乙方报账单价/数量/天数/总金额" align="right">
            <template #default="{ row }">
              <text style="color: #080">{{
                $priceFormat(row.bill_price)
              }}</text>
              <text class="text-gray-400">{{ "/" + row.bill_count }}</text>
              <text class="text-gray-400">{{
                "/" + row.bill_day_count + "/"
              }}</text>
              <strong style="color: #080">
                {{ $priceFormat(row.bill_amount) }}
              </strong>
            </template>
          </el-table-column>
          <el-table-column label="差额" align="right" :width="120">
            <template #default="{ row }">
              <c_money
                :value="row.diff"
                :key="row.diff"
                :prefix="false"
                class="!w-full justify-end"
                bold
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <strong>三、会议收款计划如下：</strong>
      <div>
        <el-table
          :data="state.meetingCollectedPlanList"
          v-loading="!Array.isArray(state.meetingCollectedPlanList)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column label="收款对象（甲方）" :width="200">
            <template #default="{ row }">
              <text>{{ row.customer?.name }}</text>
              <text class="ml-1 text-xs text-gray-400">
                {{ row.customer?.number }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            label="计划收款金额"
            prop="amount"
            align="right"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="已收"
            prop="collected_amount"
            align="right"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="欠款"
            prop="uncollected_amount"
            align="right"
            :formatter="$tab_MoneyFormat"
          />
          <el-table-column
            label="附件"
            prop="remark"
            :formatter="$tab_TextFormat"
            :width="500"
          >
            <template #default="{ row }">
              <div class="flex flex-wrap gap-x-5 gap-y-2">
                <text
                  v-for="file in row.attachment"
                  :key="item"
                  class="hover:underline cursor-pointer text-green-700"
                  @click="$openFile(file.file_url)"
                >
                  {{ file.filename }}
                </text>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meetingacounting_search,
  meetingacounting_approve,
} from "@/http/hesuanshenpi";
import { ElMessageBox, ElMessage } from "element-plus";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    search: Boolean,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        id: props.id,
      },
      meeting: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.id) {
        meetingacounting_search(props.id).then((res) => {
          if (res.status == 200) {
            const {
              meeting,
              meetingAccounting,
              meetingCollectedPlanList,
              meetingPurchaseItemList,
              flowApproveStepList,
            } = res.data?.data;
            state.meeting = meeting;
            state.meetingAccounting = meetingAccounting;
            state.meetingCollectedPlanList = meetingCollectedPlanList;
            state.meetingPurchaseItemList = meetingPurchaseItemList;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    };

    const onSubmit = (pass) => {
      if (pass == 2 && !state.remark) {
        ElMessage.warning("请输入审批说明！");
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style="color: ${pass == 1 ? "#080" : "#f00"};">${
          pass == 1 ? "同意" : "拒绝"
        }</strong>该核算申请吗？`,
        "核算审批",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meetingacounting_approve({
          id: [props.id],
          status: pass,
          msg: state.remark,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };
    return { state, props, formDom, onSubmit };
  },
};
</script>

<style lang="less" scoped></style>
